<template>
  <div class="loading-spinner el-loading-spinner">
    <svg viewBox="25 25 50 50" class="loading-spinner__svg circular">
      <circle cx="50" cy="50" r="20" fill="none" class="path" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'loading-spinner',
}
</script>

<style>
.loading-spinner {
  --default-size: 16px;

  position: relative;
  display: inline-block;
  top: 0;
  margin: 0;
  width: var(--default-size);
  height: var(--default-size);
}

.loading-spinner .loading-spinner__svg {
  width: var(--default-size);
  height: var(--default-size);
}
</style>
